import { ActionTypes } from '../constants';

const defaults = {
  deviceExternalId: null,
  apiKey: null,
  password: null,
};

export interface CacheState {
  /*  */
  deviceExternalId: string;
  apiKey: string;
  password: string;
}

export interface ActionType {
  type: string;
  payload: any;
}

export default (state: CacheState = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.UPDATE_DEVICE_INFO: {
      return { ...state, ...action.payload };
    }
    default:
      return { ...state };
  }
};
